import { render, staticRenderFns } from "./MessageComposeWarning.vue?vue&type=template&id=5c37ba54&"
import script from "./MessageComposeWarning.vue?vue&type=script&lang=js&"
export * from "./MessageComposeWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports